// utils/errorLogger/log.ts - utils/errorLogger.ts split (sub-module log)

import { canLogError } from './rateLimit.js';
import { isPriorityContext } from './classify.js';
import { buildErrorPayload, buildPayloadFromPayload, insertErrorLog, isNoiseError } from './persist.js';
import type { ErrorLogPayload } from './types.js';


export const logError = async (
    error: Error | string,
    context?: string,
    additionalInfo?: Record<string, any>
): Promise<void> => {
    if (!isPriorityContext(context) && !canLogError()) return;
    if (isNoiseError(error)) return;

    try {
        const payload = await buildErrorPayload(error, context, additionalInfo);
        await insertErrorLog(payload);
    } catch (loggingError) {
        // Silently fail - don't want to create infinite error loops
        if (import.meta.env.DEV) {
            console.error('[ErrorLogger] Exception while logging error:', loggingError);
        }
    }
};



/**
 * Log error with specific payload
 */
export const logErrorWithPayload = async (payload: ErrorLogPayload): Promise<void> => {
    if (isNoiseError(payload.errorMessage)) return;
    try {
        const fullPayload = await buildPayloadFromPayload(payload);
        await insertErrorLog(fullPayload);
    } catch (loggingError) {
        if (import.meta.env.DEV) {
            console.error('[ErrorLogger] Exception while logging error:', loggingError);
        }
    }
};
